import { Navigate, useNavigate, useParams } from "react-router-dom";
import { getTestAttempt } from "../../../api/queries.js";
import { useQuery } from "../../../api/useQuery.js";
import { AnswerReviewCard } from "../../../components/molecules/AnswerReviewCard.js";
import { LoadingRows, QueryStatus } from "../../../components/ui/LoadingPlaceholders.js";
import { Button, Card, ErrorState, ProgressBar, useT } from "@mmm/ui";
export function ScoreReviewScreen() {
  const { subjectId = "", testId = "", attemptId = "" } = useParams();
  const navigate = useNavigate();
  const t = useT();
  const query = useQuery(getTestAttempt, { attemptId });
  const basePath = `/subjects/${subjectId}/tests/${testId}/attempts/${attemptId}`;
  if (query.error && !query.waiting) return <ErrorState title={t("tests.loadScoreReviewFailed")} onRetry={query.retry} />;
  if (!query.data) return <><QueryStatus queries={[query]} /><LoadingRows rows={5} /></>;
  const { questions, attempt, test } = query.data;
  if (attempt.status === "submitted") return <Navigate to={`${basePath}/mark`} replace />;
  if (attempt.status === "inProgress") return <Navigate to={basePath} replace />;
  const awarded = questions.reduce((sum, question) => sum + (question.response?.pointsAwarded ?? 0), 0);
  const possible = questions.reduce((sum, question) => sum + (question.response?.maxPoints ?? 0), 0);
  const percent = possible ? Math.round(awarded / possible * 100) : 0;
  const testsPath = test.chapterId ? `/subjects/${subjectId}/chapters/${test.chapterId}/tests` : `/subjects/${subjectId}/tests`;
  return <div className="mmm-score-review">
    <Card padding="lg" className="mmm-review-summary">
      <div><p className="mmm-page-eyebrow">{test.title}</p><h1 className="mmm-page-title">{t("tests.scoreReview")}</h1><p>{t("tests.attemptNumber", { number: attempt.attemptNumber })}</p></div>
      <div className="mmm-review-total"><strong>{t("tests.percentValue", { percent })}</strong><p>{t("tests.scoreOutOfPoints", { awarded, count: possible })}</p><ProgressBar value={awarded} max={possible} variant="gradient" /></div>
      <Button onClick={() => navigate(testsPath)}>{t("tests.backToTests")}</Button>
    </Card>
    <div className="mmm-review-question-grid">
      {questions.slice().sort((a, b) => a.questionNumber - b.questionNumber).map((question) => <AnswerReviewCard key={question.id} question={question} />)}
    </div>
  </div>;
}
